import {http} from '../config'

export default class CarteiraService {

    Listar(id){
        return http.get(`carteira/${id}`)
    }

}